import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarBackFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.6523 12.5595V13.5683H17.2736V8.25042C14.2544 6.77435 9.59985 5.03204 9.59985 5.03204C8.92505 4.7594 8.21075 4.60235 7.48541 4.56787L3.20947 4.56689V16.9999L6.59674 16.9577C8.20795 20.5569 13.0532 20.0684 14.0508 16.3352L16.5454 15.2089H20.2929V12.5595H18.6523ZM15.6335 13.8212L12.6437 15.1711C12.2593 18.5211 8.41155 18.6229 7.68987 15.3177H4.84447V6.20684H7.42437C7.96014 6.23424 8.48528 6.35052 8.98534 6.55254C8.98534 6.55254 13.1052 8.12047 15.6335 9.32769L15.6335 13.8212Z" />
      <path d="M15.6335 13.8212L12.6437 15.1711C12.2593 18.5211 8.41155 18.6229 7.68987 15.3177H4.84447V6.20684H7.42437C7.96014 6.23424 8.48528 6.35052 8.98534 6.55254C8.98534 6.55254 13.1052 8.12047 15.6335 9.32769L15.6335 13.8212Z" />
    </SvgIcon>
  );
});
